import React from 'react';

import type { ContentItem } from '@swf/cms';

export const CMSContext = React.createContext<Record<string, ContentItem>>({});
